import {
  GET_NOTIFICATIONS_SUCCESS,
  MARK_NOTIFICATION_READ_SUCCESS,
} from "../../constants/actionTypes";

const initialState = {
  notifications: [],
};

const notifications = (state = initialState, action) => {
  switch (action.type) {
    case GET_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notifications: action.payload.notifications,
      };
    case MARK_NOTIFICATION_READ_SUCCESS:
      return {
        ...state,
        notifications: state.notifications.map((n) =>
          n.id === action.payload ? { ...n, read: true } : n
        ),
      };
    default:
      return state;
  }
};

export default notifications;
